import { __decorate, __metadata } from "tslib";
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsOptional, ValidateNested } from 'class-validator';
import { WebMerchantExposeGroup, WebStoreExposeGroup } from '../interface';
import { ReadWebMerchantAppLoginRegisterScreenDto } from './ReadWebMerchantAppLoginRegisterScreenDto';
import { ReadWebMerchantAppSharedComponentsDto } from './ReadWebMerchantAppSharedComponentsDto';
import { ReadWebMerchantCartDto } from './ReadWebMerchantCartDto';
import { ReadWebMerchantCategoriesNavBarDto } from './ReadWebMerchantCategoriesNavBarDto';
import { ReadWebMerchantCategoryMenuItemsGroupDto } from './ReadWebMerchantCategoryMenuItemsGroupDto';
import { ReadWebMerchantCustomNavigationLinkDto } from './ReadWebMerchantCustomNavigationLinkDto';
import { ReadWebMerchantFooterDto } from './ReadWebMerchantFooterDto';
import { ReadWebMerchantHeaderDto } from './ReadWebMerchantHeaderDto';
import { ReadWebMerchantHeaderLogoBlockDto } from './ReadWebMerchantHeaderLogoBlockDto';
import { ReadWebMerchantHeroBlockDto } from './ReadWebMerchantHeroBlockDto';
import { ReadWebMerchantItemModalDto } from './ReadWebMerchantItemModalDto';
import { ReadWebMerchantItemScheduleBlockDto } from './ReadWebMerchantItemScheduleBlockDto';
import { ReadWebMerchantLoyaltyBadgeDto } from './ReadWebMerchantLoyaltyBadgeDto';
import { ReadWebMerchantMenuConceptsBarDto } from './ReadWebMerchantMenuConceptsBarDto';
import { ReadWebMerchantMenuItemCardDto } from './ReadWebMerchantMenuItemCardDto';
import { ReadWebMerchantMenuItemCardMobileDto } from './ReadWebMerchantMenuItemCardMobileDto';
import { ReadWebMerchantMenuListDto } from './ReadWebMerchantMenuListDto';
import { ReadWebMerchantOrderCompleteScreenDto } from './ReadWebMerchantOrderCompleteScreenDto';
import { ReadWebMerchantOrderConfirmationDto } from './ReadWebMerchantOrderConfirmationDto';
import { ReadWebMerchantOrderReminderBannerDto } from './ReadWebMerchantOrderReminderBannerDto';
import { ReadWebMerchantOrderScreenDto } from './ReadWebMerchantOrderScreenDto';
import { ReadWebMerchantOrderSetupStatusBarDto } from './ReadWebMerchantOrderSetupStatusBarDto';
import { ReadWebMerchantOrderToTableBarDto } from './ReadWebMerchantOrderToTableBarDto';
import { ReadWebMerchantPaymentScreenDto } from './ReadWebMerchantPaymentScreenDto';
import { ReadWebMerchantPreviousOrdersListDto } from './ReadWebMerchantPreviousOrdersListDto';
import { ReadWebMerchantPromoPopupDto } from './ReadWebMerchantPromoPopupDto';
import { ReadWebMerchantPromotionsBarDto } from './ReadWebMerchantPromotionsBarDto';
import { ReadWebMerchantSocialMediaDto } from './ReadWebMerchantSocialMediaDto';
import { ReadWebMerchantTopSellingItemsSliderDto } from './ReadWebMerchantTopSellingItemsSliderDto';
export class ReadWebStoreComponentsDto {
}
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantHeaderDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantHeaderDto),
    __metadata("design:type", ReadWebMerchantHeaderDto)
], ReadWebStoreComponentsDto.prototype, "header", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantHeaderLogoBlockDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantHeaderLogoBlockDto),
    __metadata("design:type", ReadWebMerchantHeaderLogoBlockDto)
], ReadWebStoreComponentsDto.prototype, "headerLogoBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantFooterDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantFooterDto),
    __metadata("design:type", ReadWebMerchantFooterDto)
], ReadWebStoreComponentsDto.prototype, "footer", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantSocialMediaDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantSocialMediaDto),
    __metadata("design:type", ReadWebMerchantSocialMediaDto)
], ReadWebStoreComponentsDto.prototype, "socialMedia", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantPromotionsBarDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantPromotionsBarDto),
    __metadata("design:type", ReadWebMerchantPromotionsBarDto)
], ReadWebStoreComponentsDto.prototype, "promotionsBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantHeroBlockDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantHeroBlockDto),
    __metadata("design:type", ReadWebMerchantHeroBlockDto)
], ReadWebStoreComponentsDto.prototype, "heroBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantLoyaltyBadgeDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantLoyaltyBadgeDto),
    __metadata("design:type", ReadWebMerchantLoyaltyBadgeDto)
], ReadWebStoreComponentsDto.prototype, "loyaltyBadge", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantOrderSetupStatusBarDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantOrderSetupStatusBarDto),
    __metadata("design:type", ReadWebMerchantOrderSetupStatusBarDto)
], ReadWebStoreComponentsDto.prototype, "orderSetupStatusBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantOrderToTableBarDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantOrderToTableBarDto),
    __metadata("design:type", ReadWebMerchantOrderToTableBarDto)
], ReadWebStoreComponentsDto.prototype, "orderToTableBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantAppLoginRegisterScreenDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantAppLoginRegisterScreenDto),
    __metadata("design:type", ReadWebMerchantAppLoginRegisterScreenDto)
], ReadWebStoreComponentsDto.prototype, "loginRegisterScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantAppSharedComponentsDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantAppSharedComponentsDto),
    __metadata("design:type", ReadWebMerchantAppSharedComponentsDto)
], ReadWebStoreComponentsDto.prototype, "sharedComponents", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantMenuConceptsBarDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantMenuConceptsBarDto),
    __metadata("design:type", ReadWebMerchantMenuConceptsBarDto)
], ReadWebStoreComponentsDto.prototype, "menuConceptsBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantCategoriesNavBarDto }),
    Expose({
        groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE, WebStoreExposeGroup.PATCH],
    }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantCategoriesNavBarDto),
    __metadata("design:type", ReadWebMerchantCategoriesNavBarDto)
], ReadWebStoreComponentsDto.prototype, "categoriesNavBar", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantItemModalDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantItemModalDto),
    __metadata("design:type", ReadWebMerchantItemModalDto)
], ReadWebStoreComponentsDto.prototype, "itemModal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantMenuItemCardDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantMenuItemCardDto),
    __metadata("design:type", ReadWebMerchantMenuItemCardDto)
], ReadWebStoreComponentsDto.prototype, "menuItemCard", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantMenuItemCardMobileDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantMenuItemCardMobileDto),
    __metadata("design:type", ReadWebMerchantMenuItemCardMobileDto)
], ReadWebStoreComponentsDto.prototype, "menuItemCardMobile", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantMenuListDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantMenuListDto),
    __metadata("design:type", ReadWebMerchantMenuListDto)
], ReadWebStoreComponentsDto.prototype, "menuList", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantCategoryMenuItemsGroupDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantCategoryMenuItemsGroupDto),
    __metadata("design:type", ReadWebMerchantCategoryMenuItemsGroupDto)
], ReadWebStoreComponentsDto.prototype, "categoryItemsGroup", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantPromoPopupDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantPromoPopupDto),
    __metadata("design:type", ReadWebMerchantPromoPopupDto)
], ReadWebStoreComponentsDto.prototype, "promoPopup", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantTopSellingItemsSliderDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantTopSellingItemsSliderDto),
    __metadata("design:type", ReadWebMerchantTopSellingItemsSliderDto)
], ReadWebStoreComponentsDto.prototype, "topSellingItemsSlider", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantPreviousOrdersListDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantPreviousOrdersListDto),
    __metadata("design:type", ReadWebMerchantPreviousOrdersListDto)
], ReadWebStoreComponentsDto.prototype, "previousOrdersList", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantOrderReminderBannerDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantOrderReminderBannerDto),
    __metadata("design:type", ReadWebMerchantOrderReminderBannerDto)
], ReadWebStoreComponentsDto.prototype, "orderReminderBanner", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantCartDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantCartDto),
    __metadata("design:type", ReadWebMerchantCartDto)
], ReadWebStoreComponentsDto.prototype, "cartScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantOrderScreenDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantOrderScreenDto),
    __metadata("design:type", ReadWebMerchantOrderScreenDto)
], ReadWebStoreComponentsDto.prototype, "orderScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantPaymentScreenDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantPaymentScreenDto),
    __metadata("design:type", ReadWebMerchantPaymentScreenDto)
], ReadWebStoreComponentsDto.prototype, "paymentScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantOrderConfirmationDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantOrderConfirmationDto),
    __metadata("design:type", ReadWebMerchantOrderConfirmationDto)
], ReadWebStoreComponentsDto.prototype, "orderConfirmationScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantOrderCompleteScreenDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantOrderCompleteScreenDto),
    __metadata("design:type", ReadWebMerchantOrderCompleteScreenDto)
], ReadWebStoreComponentsDto.prototype, "orderCompleteScreen", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantItemScheduleBlockDto }),
    Expose({ groups: [WebStoreExposeGroup.MODEL, WebStoreExposeGroup.READ, WebStoreExposeGroup.CREATE, WebStoreExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    Type(() => ReadWebMerchantItemScheduleBlockDto),
    __metadata("design:type", ReadWebMerchantItemScheduleBlockDto)
], ReadWebStoreComponentsDto.prototype, "itemScheduleBlock", void 0);
__decorate([
    ApiPropertyOptional({ type: () => ReadWebMerchantCustomNavigationLinkDto, isArray: true, default: [] }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsArray({ always: true }),
    ValidateNested({ each: true, always: true }),
    Type(() => ReadWebMerchantCustomNavigationLinkDto),
    __metadata("design:type", Array)
], ReadWebStoreComponentsDto.prototype, "customNavigationLinks", void 0);
//# sourceMappingURL=ReadWebStoreComponentsDto.js.map